let fromDate = "";

const listeners = new Set();

export const setSchemeFromDate = (value) => {
    fromDate = value;
    listeners.forEach((fn) => fn(fromDate));
};

export const getSchemeFromDate = () => fromDate;

export const subscribeSchemeFromDate = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};
